import React from 'react'

// TOTP 잔여 시간 카운트다운 링 — 허브 칩(TotpCodeChip)과 상세 뷰(TotpFieldView) 공용.
// 시계방향으로 소진되며(관례), 남은 5초에 경고색으로 전환된다.
// 색은 사이트별 하드코딩 대신 여기서만 정의(단일 소스). 경고/기준선 색은 아직 전역 CSS
// 토큰이 없어 상수로 둔다 — 전역 --totp-* 토큰화는 후속 백로그(디자인 리뷰 ③).
const RING_TRACK = 'var(--light-border, #e5e7eb)'
const RING_NORMAL = '#5b6480'
const RING_WARNING = '#e0663b'
const LOW_THRESHOLD_SEC = 5

const TotpCountdownRing = ({ secondsRemaining, period = 30, size = 34, stroke = 3, ariaLabel }) => {
  const cycle = period > 0 ? period : 30
  const raw = typeof secondsRemaining === 'number' ? secondsRemaining : 0
  const remaining = Math.max(0, Math.min(raw, cycle))
  const progress = remaining / cycle
  const low = remaining <= LOW_THRESHOLD_SEC
  const color = low ? RING_WARNING : RING_NORMAL

  const radius = size / 2 - stroke
  const circumference = 2 * Math.PI * radius
  const half = size / 2

  // 1초 tick 사이를 부드럽게 감소시키되, 리셋(초=period) 순간엔 역방향 트위닝을 막기 위해
  // 전이를 끈다. reduced-motion 선호 시에도 끈다.
  // jsdom엔 matchMedia가 없고, CRA resetMocks가 setup의 matchMedia jest.fn 구현을 지워
  // undefined를 반환할 수 있으므로(반환 객체 유무까지 가드) 결과가 객체일 때만 .matches를 읽는다.
  const mql =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null
  const reduceMotion = mql != null && mql.matches === true
  const atBoundary = remaining >= cycle
  const transition = reduceMotion || atBoundary ? 'none' : 'stroke-dashoffset 0.9s linear'

  const a11y = ariaLabel ? { role: 'img', 'aria-label': ariaLabel } : { 'aria-hidden': true }

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        width: size,
        height: size,
        flex: 'none',
      }}
      {...a11y}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden="true"
        // scaleX(-1) 로 소진 방향을 시계방향으로 반전(rotate만 쓰면 반시계로 도는 함정)
        style={{ transform: 'scaleX(-1) rotate(-90deg)', transformOrigin: 'center' }}
      >
        <circle
          cx={half}
          cy={half}
          r={radius}
          fill="none"
          stroke={RING_TRACK}
          strokeWidth={stroke}
        />
        <circle
          cx={half}
          cy={half}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress)}
          style={{ transition }}
        />
      </svg>
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 700,
          fontVariantNumeric: 'tabular-nums',
          color,
        }}
      >
        {remaining}
      </span>
    </span>
  )
}

export default TotpCountdownRing
